<div class="row align-items-center" style="border-bottom: 1px solid #5d2041; margin-top: 1px solid #5d2041; height:68.6px">
    <div class="col">
      <div class="eventsheader">Sponsor Event</div>
    </div>
</div>
  
<div class="w-100 p-3">
    <div class="eventdiv">
        <p class="eventtitle" >Event Title</p>
        <div class="container">
            <div class="row">
                <p>Your event will be sponsored and visible to all users on the top of the events list. You will choose the geographical location of which the event will show along with the duration of the sponsorship. The cost of sponsorship is $/day. For any questions about our sponsorship service please contact: example@email.com
                </p>               
            </div>
            <div class="row">
            
            <!-- <mat-select-country appearance="outline" [countries]="predefinedCountries" label="" formControlName="country"
            (onCountrySelected)="onCountrySelected($event)">
          </mat-select-country> -->
        </div>
        <div class="row">
            <div class="container">   
                <div class="row">                   
                    <div class="col-sm" *ngFor="let package of packages"  >
                        <div class="package" 
                        [class.highlighted]="package === highlightedPackage" 
                        (click)="highlightedPackage = package" >
                        <img class="packageimage" src="{{package.image}}"> 
                            <div class="packageheader">
                                {{package.name}}
                            </div>                    
                        <div class="packagecontent">
                            <label class="packagedays">{{package.duration}}</label><br>
                            <label class="packageprice">{{package.price}}</label>
                        </div>

                    </div>
                    </div>

                </div>

              </div>
        </div>

        <div style="margin-top: 20px;" class="row">
            <button mat-button class="proceedtopayment">Proceed to Payment</button>
           
        </div>
          </div>
      
      </div>
    </div>